module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Instituição'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "value": _vm.instituicaoProjetoPesquisa.nome === null || _vm.instituicaoProjetoPesquisa.nome === '' ? '-' : _vm.instituicaoProjetoPesquisa.nome,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla",
      "value": _vm.instituicaoProjetoPesquisa.sigla === null || _vm.instituicaoProjetoPesquisa.sigla === '' ? '-' : _vm.instituicaoProjetoPesquisa.sigla,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo*",
      "items": _vm.listaTipoInstituicaoProjetoPesquisa,
      "item-text": "descricao",
      "item-value": "item",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.instituicaoProjetoPesquisa.tipoInstituicao),
      callback: function($$v) {
        _vm.$set(_vm.instituicaoProjetoPesquisa, "tipoInstituicao", $$v)
      },
      expression: "instituicaoProjetoPesquisa.tipoInstituicao"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editaInstituicaoProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42ad42cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/editar-instituicao.vue
// module id = 899
// module chunks = 0